import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for ModernGroupStore, for use in the registry */ export const ModernGroupsStoreActionTypes = [
    ActionType.DeleteModernGroupAction,
    ActionType.DeleteModernGroupFailedAction,
    ActionType.DeleteModernGroupSucceededAction,
    ActionType.FetchModernGroupAction,
    ActionType.FetchModernGroupFailedAction,
    ActionType.FetchModernGroupPhotosSucceededAction,
    ActionType.FetchModernGroupSucceededAction,
    ActionType.FetchModernGroupOwnersAction,
    ActionType.FetchModernGroupOwnersFailedAction,
    ActionType.FetchModernGroupOwnersSucceededAction,
    ActionType.FetchOneDriveUrlForModernGroupAction,
    ActionType.FetchOneDriveUrlForModernGroupFailedAction,
    ActionType.FetchOneDriveUrlForModernGroupSucceededAction,
    ActionType.FetchUserJoinedModernGroupsAction,
    ActionType.FetchUserJoinedModernGroupsFailedAction,
    ActionType.FetchUserJoinedModernGroupsSucceededAction,
    ActionType.CreateModernGroupAction,
    ActionType.CreateModernGroupFailedAction,
    ActionType.CreateModernGroupSucceededAction,
    ActionType.UpdateModernGroupAction,
    ActionType.UpdateModernGroupFailedAction,
    ActionType.UpdateModernGroupSucceededAction,
    ActionType.ModernGroupNamesValidationSucceededAction,
    ActionType.FetchModernGroupSiteUrlAndDriveIdAction,
    ActionType.FetchModernGroupSiteUrlAndDriveIdFailedAction,
    ActionType.FetchModernGroupSiteUrlAndDriveIdSucceededAction,
    ActionType.FetchModernGroupMembersSucceededAction,
    ActionType.AddModernGroupMembersAction,
    ActionType.AddModernGroupMembersFailedAction,
    ActionType.AddModernGroupMembersSucceededAction,
    ActionType.RemoveModernGroupMemberAction,
    ActionType.RemoveModernGroupMemberFailedAction,
    ActionType.RemoveModernGroupMemberSucceededAction
];
